<template>
  <div class="content-view-wrapper pd-10">
    <div
      class="content-view section-wrapper"
      ref="sectionWrapper"
      v-loading="loading"
      :element-loading-background="loadingBackground"
    >
      <section class="container"></section>
    </div>
  </div>
</template>

<script>
import listPage from "e6-base-carrier-3.0/mixins/list-page";
export default {
  name: "ElectronicRoadBooks",
  mixins: [listPage],
  data() {
    return {
      loading: false
    };
  }
};
</script>

<style></style>
